import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=17d0eeb3"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d0eeb3')) {
      api.createRecord('17d0eeb3', component.options)
    } else {
      api.reload('17d0eeb3', component.options)
    }
    module.hot.accept("./Option.vue?vue&type=template&id=17d0eeb3", function () {
      api.rerender('17d0eeb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/CompanySwitcher/Option.vue"
export default component.exports